import { FC } from 'react';
import { AnalyticsLineChart } from 'shared/ui/Analytics/AnalyticsLineChart';
import { LineChartData } from 'shared/ui/Analytics/types';
import { Col } from 'shared/ui/Col';
import { Row } from 'shared/ui/Row';
import { SmallChip } from 'shared/ui/SmallChip';
import { getRenamedLineChartData } from '../../../lib/getRenamedLineChartData';

interface ObjectClickContactsChartProps {
  pointsData: LineChartData[];
  minWidth: number;
}

const chartLines = [
  { key: 'line1', label: 'Не уникальные', color: '#CCB90B' },
  { key: 'line2', label: 'Уникальные', color: '#DA4D5E' },
];

export const ObjectClickContactsChart: FC<ObjectClickContactsChartProps> = ({
  pointsData,
  minWidth,
}) => {
  const renamedPointsData = getRenamedLineChartData(pointsData, chartLines);

  return (
    <Col>
      <AnalyticsLineChart
        data={renamedPointsData}
        lineLabels={chartLines.map((l) => l.label)}
        lineColors={chartLines.map((l) => l.color)}
        height={200}
        minWidth={minWidth}
      />

      <Row spacing={8} sx={{ alignItems: 'center' }}>
        <Row spacing={4}>
          {chartLines.map(({ label, color }) => (
            <SmallChip key={label} label={label} color={color} />
          ))}
        </Row>
      </Row>
    </Col>
  );
};
